/** @format */
import { ChangeDetectionStrategy, Component, input, InputSignal, ViewEncapsulation } from '@angular/core';

/**
 * Horizontally scrollable alternative to the vertical timeline in {@link TimelineComponent}.
 */
@Component({
    selector: 'app-horizontal-timeline',
    standalone: false,
    templateUrl: './horizontal-timeline.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalTimelineComponent {
    /** Id of the visible heading that names the scrollable region for assistive technologies. */
    readonly labelledBy: InputSignal<string> = input.required<string>();
}
